module.exports = __webpack_public_path__ + "img/BES不锈钢.9e2757a8.jpg";